import { useEffect, useState } from 'react';
import api from '../utils/api';

const FALLBACK_TEACHERS = [
  { _id: '1', name: 'Mina Park', photo: '', specialties: ['kpop', 'hip hop'], bio: 'Former backup dancer for SM Entertainment artists. 10+ years of experience teaching Kpop choreography.' },
  { _id: '2', name: 'Wei Chen', photo: '', specialties: ['chinese', 'contemporary'], bio: 'Classically trained in Beijing Dance Academy. Blends traditional Chinese dance with modern expression.' },
  { _id: '3', name: 'Jisoo Kim', photo: '', specialties: ['kpop', 'contemporary'], bio: 'Choreographer and dancer specializing in Kpop girl-group style and lyrical movement.' },
];

export default function Teachers() {
  const [teachers, setTeachers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    api.get('/classes/teachers/all')
      .then(({ data }) => {
        if (cancelled) return;
        setTeachers(data.length ? data : FALLBACK_TEACHERS);
      })
      .catch((err) => {
        if (cancelled) return;
        setError(err.response?.data?.error || 'Could not load teachers');
        setTeachers(FALLBACK_TEACHERS);
      })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  return (
    <>
      <div className="page-header">
        <div className="container">
          <p className="section-label">Our Team</p>
          <h1>Instructors</h1>
          <p>Industry professionals with a passion for teaching.</p>
        </div>
      </div>
      <section className="section">
        <div className="container">
          {loading && <p style={{ textAlign: 'center', color: 'var(--text-muted)' }}>Loading...</p>}
          {error && <p style={{ textAlign: 'center', color: '#ef5350' }}>{error}</p>}
          {!loading && (
            <div className="grid grid-3">
              {teachers.map((t) => (
                <div className="teacher-card" key={t._id}>
                  <img
                    src={t.photo || `https://placehold.co/200x200/1a1a1a/c9a96e?text=${t.name.charAt(0)}`}
                    alt={t.name}
                  />
                  <h3>{t.name}</h3>
                  <div className="teacher-role">Instructor</div>
                  <p style={{ fontSize: '0.875rem', lineHeight: 1.8 }}>{t.bio}</p>
                  <div className="teacher-specialties">
                    {t.specialties.map((s) => <span className="tag" key={s}>{s}</span>)}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
}
